import React, { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
// import util from 'util';
import constClass from '../../Constants/Constants';
import { useToasts } from 'react-toast-notifications';
import { useParams } from 'react-router';
import DatePicker from "react-datepicker"
import "react-datepicker/dist/react-datepicker.css"
import moment from 'moment';
import Select from 'react-select';

const PointCampaign = (props) => {
  const { user } = props;
  const { siteId, mallId } = useParams();
  const [shopGroupMaster, setShopGroupMaster] = useState([]);
  const [mallData, setMallData] = useState(null);
  const [campaignData, setCampaignData] = useState(null);
  const [lockData, setLockData] = useState(false);
  const { addToast } = useToasts();

  const [values, setValues] = useState({
    site_id: siteId,
    point_campaign_id: null,
    mall_id: mallId,
    point_campaign_name: '',
    start_date: null,
    end_date: null,
    point_limit: null,
    payment_method: 0,
    shop_set_flg: null,
    m_point_campaign_sub: [],
    m_point_campaign_shop: []
  });
  const PAGE_SIZE = 5;

  const [campaignShop, setCampaignShopValues] = useState([]);
  const [searchKeyword, setSearchKeyword] = useState('');
  const [currentPage, setCurrentPage] = useState(1);

  const refreshData = useCallback(async () => {
    setLockData(true);
    var resdata = null;
    try {
      //トークンを取得
      const jwt = localStorage.getItem('jwt');
      const shop = (await axios.get(`${process.env.REACT_APP_BACKEND_URL}/shopgroup/${siteId}/${mallId}`, { headers: { Authorization: `Bearer ${jwt}` } }))
        .data.map((val) => { return { value: val.shop_group_id, label: val.shop_group_name }; });
      setShopGroupMaster(shop);

      const mall = (await axios.get(`${process.env.REACT_APP_BACKEND_URL}/mall/${siteId}/${mallId}`, { site_id: siteId }, {
        headers: {
          Authorization: `Bearer ${jwt}`,
        }
      })).data;
      setMallData(mall);

      resdata = (await axios.post(`${process.env.REACT_APP_BACKEND_URL}/point_campaign/search`, { site_id: siteId, mall_id: mallId }, { headers: { Authorization: `Bearer ${jwt}` } })).data;

      if (Array.isArray(resdata) && resdata.length > 0){
        const processedData = resdata.map((item) => ({
          site_id: siteId,
          mall_id: mallId,
          point_campaign_id: item.point_campaign_id || null,
          point_campaign_name: item.point_campaign_name || null,
          start_date: item.start_date || null,
          end_date: item.end_date || null,
          point_limit: item.point_limit || null,
          payment_method: item.payment_method ?? 0,
          shop_set_flg: item.shop_set_flg || null,
          m_point_campaign_shop: item.m_point_campaign_shop || null,
          m_point_campaign_sub: item.m_point_campaign_sub || null,
          upd_date: item.upd_date || null,
        }));

        setCampaignData(processedData);
      } else {
        // resdataが空の場合の処理
        setCampaignData([]);
      }
    } catch (error) {
      console.error(error);
      setCampaignData([]);
    } finally {
      setLockData(false);
    }
  }, [siteId, mallId]);

  /* DB更新 */
  const handleRegistClick = async () => {
    const jwt = localStorage.getItem('jwt');
    if (!values.point_campaign_name) {
      window.alert('キャンペーン名を入力してください。');
      return;
    }
    if (!values.start_date || !values.end_date) {
      window.alert('キャンペーン期間を入力してください。');
      return;
    }
    if (moment(values.start_date) > moment(values.end_date)) {
      window.alert('キャンペーン期間が間違っています。');
      return;
    }
    if (values.point_limit) {
      if (!(String(values.point_limit)).match(/^(?!0)[0-9]+$/)) {
        window.alert('ポイント上限は正の半角整数で入力してください。');
        return;
      }
      if (Number(values.point_limit) < mallData.point_limit) {
        window.alert('施設マスタで設定しているポイント上限より大きい数値を入力してください。');
        return;
      }
    }
    var params = structuredClone(values);
    params.ins_name = user.userId;
    params.upd_name = user.userId;
    params.site_id = siteId;
    params.mall_id = mallId;
    params.m_point_campaign_sub = values.m_point_campaign_sub.filter((x, idx, self) =>
      self.findIndex((e) => Number(e.magnification) === Number(x.magnification)) === idx
      && Number(x.magnification) > 0 && Number(x.percent) > 0 && (Number(x.cost_mall) > 0 || Number(x.cost_shop) > 0)
    );
    params.m_point_campaign_shop = campaignShop.map(shop => ({ site_id: siteId, point_campaign_id: values.point_campaign_id, shop_group_id: shop.value }));
    params.shop_set_flg = (params.m_point_campaign_shop.length > 0) ? constClass.FLAG.ON : constClass.FLAG.OFF;
    if (params.m_point_campaign_sub.length === 0 || params.m_point_campaign_sub.length !== values.m_point_campaign_sub.length) {
      window.alert(`ポイント倍率${values.m_point_campaign_sub.length > 0 ? "の入力が間違っています。ただしく" : "を"}入力してください`);
      return;
    }
    
    let resPointCampaign1 = null;
    let resPointCampaign2 = null;

    try {
      resPointCampaign1 = (await axios.post(`${process.env.REACT_APP_BACKEND_URL}/point_campaign/list/`, { site_id: siteId, mall_id: mallId, datetime: values.start_date }, {
          headers: {
              Authorization: `Bearer ${jwt}`,
          }
      })).data;

      resPointCampaign2 = (await axios.post(`${process.env.REACT_APP_BACKEND_URL}/point_campaign/list/`, { site_id: siteId, mall_id: mallId, datetime: values.end_date }, {
          headers: {
              Authorization: `Bearer ${jwt}`,
          }
      })).data;
    } catch (err) {
        console.log(err);
        return;
    }

    const combinedCampaigns = [...new Set([...resPointCampaign1, ...resPointCampaign2].map(campaign => campaign.point_campaign_id))].filter(id => id !== params.point_campaign_id);

    if (combinedCampaigns.length > 0) {
      if (!window.confirm(`他のポイントキャンペーンが開催中です。\n登録してよろしいですか？`)) {
          return;
      }
    } else {
      if (!window.confirm(`登録してよろしいですか？`)) {
        return;
      }
    }

    let res;
    try {
      setLockData(true);
      res = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/point_campaign/`, params, {
        headers: {
          Authorization: `Bearer ${jwt}`
        }
      });
    } catch (err) {
      console.log(err);
      if (err.response.data !== null) {
        addToast(err.response.data.msg, { appearance: 'error', autoDismiss: true });
      } else {
        addToast(err.response, { appearance: 'error', autoDismiss: true });
      }
    } finally {
      if (!res) {
      } else if (res.data.error) {
        addToast(res.data.message, { appearance: 'error', autoDismiss: true });
      } else {
        addToast('登録しました。', { appearance: 'success', autoDismiss: true });
        await refreshData();
      }
      setLockData(false);
      handleResetClick();
    }
  }
  /* DB削除 */
  const handleDeleteClick = async (data) => {
    const jwt = localStorage.getItem('jwt');

    if (!window.confirm(`キャンペーン[${data.point_campaign_id}:${data.point_campaign_name}]を削除します。\nよろしいですか？`)) {
      return;
    }
    const params = {
      site_id: siteId,
      point_campaign_id: data.point_campaign_id,
      upd_date: data.upd_date
    };
    let res;
    try {
      setLockData(true);
      res = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/point_campaign/delete/`, params, {
        headers: {
          Authorization: `Bearer ${jwt}`,
        }
      });
    } catch (err) {
      if (err.response.data !== null) {
        addToast(err.response.data.msg, { appearance: 'error', autoDismiss: true });
      } else {
        addToast(err.response, { appearance: 'error', autoDismiss: true });
      }
    } finally {
      if (res.data.error) {
        addToast(res.data.message, { appearance: 'error', autoDismiss: true });
      } else {
        addToast('削除しました。', { appearance: 'success', autoDismiss: true });
        await refreshData();
      }
      setLockData(false);
      handleResetClick();
    }
  }
  /* 編集ボタン押下 */
  const handleUpdateClick = (data) => {
    const data1 = structuredClone(data)
    setValues(data1);
    var data_shop = data.m_point_campaign_shop.map((a) => ({ value: a.shop_group_id, label: shopGroupMaster.find(x => x.value.toString() === a.shop_group_id.toString()).label }));
    setCampaignShopValues(data_shop);
  }

  /* RESETボタン押下 */
  const handleResetClick = () => {
    setValues({
      site_id: siteId,
      point_campaign_id: null,
      mall_id: mallId,
      point_campaign_name: '',
      start_date: null,
      end_date: null,
      point_limit: null,
      payment_method: 0,
      shop_set_flg: null,
      m_point_campaign_sub: [],
      m_point_campaign_shop: []
    });
    setCampaignShopValues([])
  }

  const renderUpdateButton = (data) => {
    return (
      <button
        className={`btn btn-primary mx-1`}
        onClick={() => handleUpdateClick(data)}>
        編集
      </button>
    )
  }

  const renderRegistButton = (data) => {
    return (
      <button type="button"
        disabled={lockData || values.m_point_campaign_sub.length === 0}
        className={`btn btn-primary mx-1 w-50`}
        onClick={() => handleRegistClick(data)}>
        登録
      </button>
    )
  }

  const renderDeleteButton = (data) => {
    return (
      <button type="button"
        disabled={lockData || data.point_campaign_id === null}
        className={`btn btn-primary mx-1 w-50`}
        onClick={() => handleDeleteClick(data)}>
        削除
      </button>
    )
  }
  const renderSubAddButton = () => {
    return (
      <button type="button"
        disabled={lockData}
        className={`btn btn-primary mx-1 px-3`}
        onClick={() => handleAddSub()}>
        行追加
      </button>
    )
  }
  const renderSubDeleteButton = (idx) => {
    return (
      <button type="button"
        disabled={lockData}
        className={`btn btn-primary mx-1 px-3 text-nowrap`}
        onClick={() => handleDeleteSub(idx)}>
        削除
      </button>
    )
  }
  const renderResetButton = () => {
    return (
      <button type="button"
        disabled={false}
        className={`btn btn-primary mx-1 w-50`}
        onClick={() => handleResetClick()}>
        リセット
      </button>
    )
  }

  const handleChange = (e) => {
    const target = e.target;
    const value = target.type === "checkbox" ? (target.checked ? constClass.FLAG.ON : constClass.FLAG.OFF) : target.value;
    const name = target.name;
    setValues({ ...values, [name]: value });
  }

  const handlePaymentMethod = (type) => {
    if (type === values.payment_method) {
      setValues({ ...values, "payment_method": 0 });
    } else {
      setValues({ ...values, "payment_method": type });
    }
  }
  const handleChangeSub = (e, idx) => {
    const target = e.target;
    const value = target.value;
    const name = target.name;
    var data = values.m_point_campaign_sub;
    data[idx] = { ...data[idx], [name]: value }
    setValues({ ...values, "m_point_campaign_sub": data });
  }
  const handleChangeDate = (name, value) => {
    if (name === "end_date") {
      // 終了日は23:59:59にする
      value = moment(value).endOf('day').toDate();
    } else {
      // 開始日は00:00:00にする
      value = moment(value).startOf('day').toDate();
    }
    setValues({ ...values, [name]: value });
  }
  const handleChangeShop = (data) => {
    setCampaignShopValues(data);
  }

  /* ポイントキャンペーン確率行追加ボタン押下 */
  const handleAddSub = () => {
    var data = values.m_point_campaign_sub;
    data.push({
      site_id: values.site_id,
      point_campaign_id: values.point_campaign_id,
      magnification: null,
      percent: null,
      cost_mall: null,
      cost_shop: null
    })
    setValues({ ...values, "m_point_campaign_sub": data });
  }
  /* ポイントキャンペーン確率削除ボタン押下 */
  const handleDeleteSub = (idx) => {
    var data = values.m_point_campaign_sub
    data.splice(idx, 1);
    setValues({ ...values, "m_point_campaign_sub": data });
  }

  useEffect(() => {
    refreshData();
  }, [refreshData]); //

  const renderInput = () => {
    return (
      <div className="mx-1">
        <div className="row mb-3">
          <div className="col-2 text-center align-self-center">
            <span>キャンペーンID</span>
          </div>
          <div className="col-2 text-center align-self-center">
            <input type="text" className="form-control" name="point_campaign_id" defaultValue={values.point_campaign_id} placeholder="新規" readOnly />
          </div>
        </div>
        <div className="row mb-3">
          <div className="col-2 text-center align-self-center">
            <span>キャンペーン名</span>
          </div>
          <div className="col-5 text-center align-self-center">
            <input type="text" className="form-control" name="point_campaign_name" value={values.point_campaign_name} onChange={handleChange} placeholder="キャンペーン名を入力してください" />
          </div>
        </div>

        <div className="row mb-3">
          <div className="col-2 text-center align-self-center">
            <label htmlFor="campaignStart">キャンペーン開始日</label>
          </div>
          <div className="col-3 text-center align-self-center">
            <DatePicker className="custom-select w-100 text-center border-textbox text-primary font-weight-bold" aria_labal="キャンペーン開始日" locale="ja" dateFormat="yyyy/MM/dd" monthsShown="1" id="start_date" name="start_date"
              selected={values.start_date ? new Date(values.start_date) : null}
              maxDate={values.end_date ? new Date(values.end_date) : null}
              onChange={date => handleChangeDate("start_date", date ? date : null)}
              placeholderText="- 選択 -"
              onFocus={(e) => e.target.blur()}
            />
          </div>
          <div className="col-2 text-center align-self-center">
            <label htmlFor="campaignEnd">キャンペーン終了日</label>
          </div>
          <div className="col-3 text-center align-self-center">
            <DatePicker className="custom-select w-100 text-center border-textbox text-primary font-weight-bold" aria_labal="キャンペーン開始日" locale="ja" dateFormat="yyyy/MM/dd" monthsShown="1" id="end_date" name="end_date"
              selected={values.end_date ? new Date(values.end_date) : null}
              minDate={values.start_date ? new Date(values.start_date) : null}
              onChange={date => handleChangeDate("end_date", date ? date : null)}
              placeholderText="- 選択 -"
              onFocus={(e) => e.target.blur()}
            />
          </div>
        </div>
        <div className="row mb-3">
          <div className="col-2 text-center align-self-center">
            <label htmlFor="point_limit">ポイント上限</label>
          </div>
          <div className="col-5 text-left align-self-center">
            <input type="text" className="form-control" id="point_limit" name="point_limit" value={values.point_limit || ''} onChange={handleChange} />
          </div>
        </div>

        <div className="row mb-3">
          <div className="col-2 text-center">
            <span>対象店舗グループ</span>
          </div>
          <div className="col-10 text-left">
            <Select options={shopGroupMaster} isMulti closeMenuOnSelect={false} value={campaignShop} onChange={handleChangeShop} placeholder="対象店舗グループを選択してください" />
          </div>
        </div>
        <div className='row mb-3'>
          <div className='col-2 text-center'>
            <span>対象決済手段</span>
          </div>
          <div className='col-10 text-left'>
            <div className='row'>
              {Object.keys(constClass.PAYMENT_METHOD).map((p, idx) =>
                <div key={idx} className={`col-2 p-1`}>
                  <button
                    className={`btn ${(values.payment_method ?? 0).toString() === constClass.PAYMENT_METHOD[p] ? "btn-active" : "btn-enable"} w-100 py-2`}
                    onClick={() => { handlePaymentMethod(constClass.PAYMENT_METHOD[p]) }}>
                    {constClass.PAYMENT_METHOD_NAME[p]}
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
        <div className='row mb-3'>
          <div className='col-12 text-center'>
            <table className="table table-bordered table-striped">
              <thead className={`table-info`}>
                <tr>
                  <td className="text-center align-middle">
                    ID
                  </td>
                  <td className="text-center align-middle">
                    ポイント倍率
                  </td>
                  <td className="text-center align-middle">
                    確率
                  </td>
                  <td className="text-center align-middle">
                    施設負担
                  </td>
                  <td className="text-center align-middle">
                    店舗負担
                  </td>
                  <td className="text-center align-middle">
                    処理
                  </td>
                </tr>
              </thead>
              <tbody>
                {values.m_point_campaign_sub.length === 0 && <tr><td colSpan={6} className='text-center'>データがありません</td></tr>}
                {values.m_point_campaign_sub.map((data, idx) => (
                  <tr key={idx}>
                    <td className="text-center align-middle">
                      {(idx + 1)}
                    </td>
                    <td className="text-center align-middle">
                      <input type="text" className="form-control" name="magnification" value={data.magnification || ""} onChange={e => handleChangeSub(e, idx)} />
                    </td>
                    <td className="text-center align-middle">
                      <input type="text" className="form-control" name="percent" value={data.percent || ""} onChange={e => handleChangeSub(e, idx)} />
                    </td>
                    <td className="text-center align-middle">
                      <input type="text" className="form-control" name="cost_mall" value={data.cost_mall || ""} onChange={e => handleChangeSub(e, idx)} />
                    </td>
                    <td className="text-center align-middle">
                      <input type="text" className="form-control" name="cost_shop" value={data.cost_shop || ""} onChange={e => handleChangeSub(e, idx)} />
                    </td>
                    <td className="text-center align-middle">
                      {renderSubDeleteButton(idx)}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <div className='col-12 text-right'>
            {renderSubAddButton()}
          </div>
        </div>
        <div className="row mb-2 pb-4">
          <div className="col-3 text-center">
            {renderRegistButton()}
          </div>
          <div className="col-3 text-center">
            {renderDeleteButton(values)}
          </div>
          <div className="col-3 text-center">
            {renderResetButton()}
          </div>
        </div>
      </div>
    );
  }

  const renderList = () => {
    const filteredData = campaignData.filter(data =>
      !searchKeyword || data.point_campaign_name.includes(searchKeyword)
    );
    const totalPages = Math.ceil(filteredData.length / PAGE_SIZE);
    const pagedData = filteredData.slice((currentPage - 1) * PAGE_SIZE, currentPage * PAGE_SIZE);

    return (
      <div className="row mb-3  mt-3 p-0">
        <div className="col-12 mb-2">
          <div className="row">
            <input
              type="text"
              className="col-4 form-control"
              placeholder="キャンペーン名で絞り込み"
              value={searchKeyword}
              onChange={e => { setSearchKeyword(e.target.value); setCurrentPage(1); }}
            />
          </div>
        </div>
        <div className="col-12 p-0">
          <div className="d-flex justify-content-between align-items-center mb-1">
            <span className="small text-muted">{filteredData.length}件中 {Math.min((currentPage - 1) * PAGE_SIZE + 1, filteredData.length)}〜{Math.min(currentPage * PAGE_SIZE, filteredData.length)}件表示</span>
            {totalPages > 1 && (
              <nav>
                <ul className="pagination pagination-sm mb-0">
                  <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                    <button className="page-link" onClick={() => setCurrentPage(p => p - 1)}>‹</button>
                  </li>
                  {Array.from({ length: totalPages }, (_, i) => i + 1).map(page => (
                    <li key={page} className={`page-item ${currentPage === page ? 'active' : ''}`}>
                      <button className="page-link" onClick={() => setCurrentPage(page)}>{page}</button>
                    </li>
                  ))}
                  <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                    <button className="page-link" onClick={() => setCurrentPage(p => p + 1)}>›</button>
                  </li>
                </ul>
              </nav>
            )}
          </div>
          <table className="table table-bordered table-striped">
            <thead className={`table-info`}>
              <tr>
                <td className="text-center align-middle">
                  キャンペーンID
                </td>
                <td className="text-center align-middle">
                  キャンペーン名
                </td>
                <td className="text-center align-middle">
                  キャンペーン期間
                </td>
                <td className="text-center align-middle">
                  処理
                </td>
              </tr>
            </thead>
            <tbody>
              {filteredData.length === 0 && <tr><td colSpan={4} className='text-center'>データがありません</td></tr>}
              {pagedData.map((data) => (
                <tr key={data.point_campaign_id}>
                  {/* キャンペーンID */}
                  <td className="text-center align-middle">
                    {data.point_campaign_id}
                  </td>
                  {/* キャンペーン名 */}
                  <td className="text-center align-middle">
                    {data.point_campaign_name}
                  </td>
                  {/* キャンペーン期間 */}
                  <td className="text-center align-middle">
                    {moment(data.start_date).format('YYYYMMDD')}～{moment(data.end_date).format('YYYYMMDD')}
                  </td>
                  {/* 処理 */}
                  <td className="text-center align-middle text-nowrap">
                    {renderUpdateButton(data)}
                  </td>
                </tr>
              ))
              }
            </tbody>
          </table>
        </div>
      </div>
    );
  }

  return (
    <div className="container">

      {campaignData === null && <div className="row"><div className="col-12">読み込み中・・・</div></div>}
      {campaignData !== null && (renderList())}
      {renderInput()}
    </div>
  )
}

export default PointCampaign;